import React, {Fragment, useEffect, useRef, useState} from "react";
import {Badge, Card, CardBody, Col, FormGroup, Input, Label, Media, Alert,  Modal,  ModalHeader,  ModalBody,  ModalFooter,  Spinner} from "reactstrap";
import ImageUploader from 'react-images-upload';
import {openNewDialog} from "../../../../manage-user/store/userSlice";
import {Button, Row} from "react-bootstrap";
import DropZone from "../../../../../share-components/upload/dropzone";
import {useDispatch} from "react-redux";
import dragula from 'react-dragula';
import {
    addProductImage,
    deleteProductImage,
    sortProductImage,
    updateProductImageAlt,
    generateAiProductImages,
    retouchAiProductImages,
} from "../../../store/prodcutSlice";
import {get} from "react-hook-form";
import {getFileExtension} from "../../../../../utils/common";
import {checkAiImageReadinessApi} from "../../../../../services/manage-product/productService";


import ReactImageVideoLightbox from "react-image-video-lightbox";
import Select from "react-select";
import {toast} from "react-toastify";
import { MdAutoAwesome } from "react-icons/md";
import SweetAlert from "sweetalert2";

const ProductImage = (props) => {
    const {productState, setValue, trigger, getValues,onConfirmSendImage,currentUser} = props;
    const dispatch = useDispatch();
    let imageAltRef = useRef([]);
    //const roleRegister = register("role", { required: true });
    const [image, setimage] = useState({pictures: []})
    const [imagePreloader, setImageLoader] = useState(false);
    const [isDragInit, setIsDragInit] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);

    const [viewFile, setViewFile] = useState([]);
    const [dragulaKey, setDragulaKey] = useState(0);

    const [aiMode, setAiMode] = useState(null); // "generate" | "retouch" | null
    const [aiPrompt, setAiPrompt] = useState("");
    const [aiAspectRatio, setAiAspectRatio] = useState("1:1");
    const [aiProcessing, setAiProcessing] = useState(false); // full-screen overlay (actual generation only)
    const [aiSubmitting, setAiSubmitting] = useState(false); // button busy state — covers the readiness check too
    const aiSubmittingRef = useRef(false); // synchronous guard against rapid double-clicks (before re-render disables the button)
    const [aiNumImages, setAiNumImages] = useState(null);
    const [aiShotTypes, setAiShotTypes] = useState([]);
    const [aiColourId, setAiColourId] = useState(null);


    const onDrop = (pictureFiles, pictureDataURLs) => {
        setimage({
            ...image, pictureFiles
        });
    }
    const onChangeFile =(e,error) => {

        if(error.length>0){
            toast.error("one or many of the uploaded file size more than 20MB", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }else {
            if (e.length > 0) {
                setImageLoader(true);
                dispatch(addProductImage({
                    id: getValues('id'),
                    image: e,
                    shopify_product_id: getValues('shopify_product_id')
                })).then(res => {
                    if (!res.error) {
                        setValue('images', res.payload);
                        trigger('images');
                        setDragulaKey(dragulaKey + 1);
                        setImageLoader(false);
                    }
                    ;
                });
            }
        }
    };

    let dragulaDecoratorRight = (componentBackingInstance) => {
        if (componentBackingInstance) {
            if (!isDragInit) {
                let imageContainer = dragula([componentBackingInstance], {
                    isContainer: function (el) {
                        return false; // only elements in drake.containers will be taken into account
                    },
                    moves: function (el, source, handle, sibling) {
                        return true; // elements are always draggable by default
                    },
                    accepts: function (el, target, source, sibling) {
                        return true; // elements can be dropped in any of the `containers` by default
                    },
                    invalid: function (el, handle) {
                        return false; // don't prevent any drags from initiating by default
                    },
                });
                imageContainer.on('drop', (el, target, source, sibling) => {
                    const cardOrder = source.childNodes;
                    let imageIds = [];
                    cardOrder.forEach(item => {
                        imageIds.push(item.getAttribute('data-id'))
                    });
                    dispatch(sortProductImage({id: getValues('id'), image_ids: imageIds}));
                });
                setIsDragInit(true);
            }
        }
    };

    const deleteImage = (item) => {
        dispatch(deleteProductImage(item.id)).then(res => {
            if (!res.error) {
                setValue('images', res.payload);
                trigger('images');
                setDragulaKey(dragulaKey + 1);
                setIsDragInit(false);
            }
        });
    }
    const initilindex = {index: 0, isOpen: false}
    const [photoIndex, setPhotoIndex] = useState(initilindex)
    const [selectedColour,setSelectedColour]=useState(0);

    // const onMovePrev = () => {
    //     const prev = (photoIndex.index + getValues('images').length - 1) % getValues('images').length
    //     setPhotoIndex({...photoIndex, index: prev})
    //     imageAltRef.current[photoIndex.index].value = getValues('images')[prev].image_alt;
    // }
    const onMoveNext = (index) => {
        imageAltRef.current.value = getValues('images')[index].image_alt;
        setSelectedColour(getValues('images')[index].colour_id);
    }
    const updateImageAltText = (index) => {
        let imageText = imageAltRef.current;
        getValues('images')[photoIndex.index].image_alt = imageText.value;
        setIsUpdated(true);

    }
    const setImageColour=(index,item)=>{
        getValues('images')[photoIndex.index].colour_id = item.id;
        getValues('images')[photoIndex.index].colour = item;
        setSelectedColour(item.id);
        setIsUpdated(true);
    }
    const updateAltTagWithColour=()=>{
        if(isUpdated) {
            const images = getValues('images').map(elem => (
                {
                    id: elem.id,
                    colour_id: elem.colour_id,
                    image_alt:elem.image_alt
                }
            ));
            dispatch(updateProductImageAlt({images:images})).then(res => {
                if (!res.error) {
                   setIsUpdated(false);
                }
            });
        }

    }
    useEffect(()=>{
        if(photoIndex.isOpen) {
            setSelectedColour(getValues('images')[photoIndex.index].colour_id);
            imageAltRef.current.value = getValues('images')[photoIndex.index].image_alt;
        }
    },[photoIndex.index,photoIndex.isOpen])
    useEffect(() => {
        let dataImage = [];
        getValues('images').map((item, i) => {
            dataImage.push({
                url: item.image_path,
                type: getFileExtension(item.image_path) == ".mp4" ? "video" : "photo",
                altTag: "some image",
            });
        });
        setViewFile(dataImage);
    }, [getValues('images')]);

    const hasImagesOnly = (media = []) => (media || []).some(item => getFileExtension(item.image_path) !== ".mp4");

    return (
        <Fragment>
            {aiProcessing && (
                <div
                    style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(255,255,255,0.7)",
                    zIndex: 2000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: 12,
                    }}
                >
                    <Spinner />
                    <div style={{ fontWeight: 500 }}>
                    {aiMode === "generate" ? "Generating images…" : "Retouching images…"}
                    </div>
                </div>
            )}
            <Card>
                <CardBody>
                    <div className="ribbon ribbon-clip ribbon-primary ribbon-left mb-5">Images</div>

                    <div className="d-flex justify-content-end mb-2">
                        <div className="d-flex align-items-center gap-2">
                            {/* Generate Images – always visible */}
                            <Button
                            type="button"
                            color="primary"
                            size="sm"
                            onClick={() => setAiMode("generate")}
                            className="d-flex align-items-center gap-1"
                            >
                            <MdAutoAwesome style={{ fontSize: 16 }} /> &nbsp;&nbsp;
                            Generate Images
                            </Button>

                            {/* Retouch Images – hidden for now */}
                            {/*{hasImagesOnly(getValues("images")) && (
                            <Button
                                type="button"
                                color="secondary"
                                size="sm"
                                onClick={() => setAiMode("retouch")}
                                className="d-flex align-items-center gap-1 ml-3"
                            >
                                <MdAutoAwesome style={{ fontSize: 16 }} /> &nbsp;&nbsp;
                                Retouch Images
                            </Button>
                            )}*/}
                        </div>
                    </div>

                    <div className="form-row mb-3 mt-3">
                        <div className="col-4 offset-8">
                            <Alert color="primary outline">
                                <span>{"Videos can be uploaded after publish"}</span>
                            </Alert>
                        </div>
                    </div>
                    <div className="form-row mb-3">

                        <div ref={dragulaDecoratorRight} style={{display: "contents"}} key={dragulaKey}>
                            {getValues('images').map((item, i) => <Col md={2} index={i} data-id={item.id} key={i}>


                                <Card>
                                    <div className="product-box">
                                        <div className="product-img">
                                            <div><Badge key={i} onClick={()=>{
                                                setImageColour(photoIndex.index,item);
                                            }}  className={`image-color badge bg-light text-dark`}>{item.colour?item.colour.name:"None"}</Badge></div>
                                            {item.is_ai_generated &&
                                                <div style={{position: "absolute", top: 8, right: 8, zIndex: 5}}>
                                                    <Badge className="badge bg-primary text-white d-flex align-items-center"
                                                           style={{gap: 3}}
                                                           title="This image was generated by AI">
                                                        <MdAutoAwesome/> AI
                                                    </Badge>
                                                </div>}
                                            <div className="image-crop-center" style={{height: 200}}>
                                                {getFileExtension(item.image_path) == ".mp4" ?
                                                    <video height="200" width={350} autoPlay={true} muted={true}
                                                           loop={true}>
                                                        <source src={item.image_path} type="video/mp4"/>
                                                    </video>
                                                    : <img className="img-fluid scale-image-6" src={item.image_path}
                                                           alt=""/>}
                                            </div>
                                            <div className="product-hover">
                                                <ul>
                                                    <li>
                                                        <Button color="default" onClick={() => {
                                                            setPhotoIndex({...photoIndex, index: i, isOpen: true})
                                                        }}>
                                                            <i className="icon-eye"></i>
                                                        </Button>
                                                    </li>
                                                    <li>
                                                        <Button color="red" onClick={() => {
                                                            deleteImage(item)
                                                        }}>
                                                            <i className="icon-trash"></i>
                                                        </Button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/*<div className="product-details text-center">*/}
                                        {/*    <h6 className="font-primary" >test</h6>*/}
                                        {/*</div>*/}
                                    </div>
                                </Card>


                            </Col>)}
                        </div>
                        <Col md={2}>
                            <Card>
                                <div className="product-box">
                                    <div className="product-img pt-3 pb-3">
                                        {imagePreloader && <div className="loader-box">
                                            <div className="loader-2"></div>
                                        </div>}
                                        {!imagePreloader && <DropZone multiple
                                            // acceptFiles={getValues('shopify_product_id')?"image/*,.mp4":"image/*"}
                                            extension={getValues('shopify_product_id') ? "image/*,.mp4" : "image/*"}
                                            onChangeFile={onChangeFile}></DropZone>}
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </div>
                    {(currentUser.modules).includes('send-image') &&   <div className="form-row">
                        <div className="col-4 offset-8">
                            <Button onClick={onConfirmSendImage} className="pull-right  font-weight-bold mr-2" color="success"
                                    type="button">Send Image
                            </Button>
                        </div>
                    </div>}
                </CardBody>
            </Card>
            {photoIndex.isOpen && (
                <div style={{height: '100vh'}}>
                    <div className="lightbox-div">
                        <ReactImageVideoLightbox
                            title={"DAd"}
                            data={viewFile}
                            startIndex={photoIndex.index}
                            showResourceCount={true}
                            onCloseCallback={() => {
                                updateAltTagWithColour();
                                setPhotoIndex({...photoIndex, isOpen: false})
                            }}
                            onNavigationCallback={(currentIndex) =>{

                                setPhotoIndex({...photoIndex, index: currentIndex})
                                onMoveNext(currentIndex);
                            }}
                        >

                        </ReactImageVideoLightbox>
                        <div className="p-5" style={{zIndex: 300, bottom: 0, position: "fixed", right: 0}}>
                            <div>
                                <input name="altText" type="text"
                                       placeholder="Alt Text"
                                       ref={(ref)=>{
                                           imageAltRef.current=ref;
                                       }}
                                       onBlur={(e) => {
                                           updateImageAltText(photoIndex.index);
                                       }}
                                       className={`form-control`}/>
                            </div>
                            <div className="pt-2">
                                    {getValues('color').map((item, i) => <Badge key={i} onClick={()=>{
                                        setImageColour(photoIndex.index,item);
                                    }}  className={`image-color badge bg-light text-dark ${selectedColour == item.id?`active-image-color`:""}`}>{item.name}</Badge>)}

                            </div>
                        </div>
                    </div>

                </div>
            )}
            <Modal isOpen={!!aiMode} toggle={() => setAiMode(null)} centered size="lg">
                <ModalHeader toggle={() => setAiMode(null)}>
                    <div>
                        <div style={{ fontWeight: 600 }}>
                        {aiMode === "generate"
                            ? "Generate Images with AI"
                            : "Retouch Images with AI"}
                        </div>


                        <div style={{ fontSize: 13, color: "#6c757d", marginTop: 4 }}>
                        {aiMode === "generate"
                            ? "Create new product visuals, variations, or scenes from scratch using AI."
                            : "Enhance clarity, improve lighting, sharpen details, and clean up visuals of existing images."}
                        </div>
                    </div>
                </ModalHeader>

                <ModalBody>
                    {aiMode === "generate" && (
                        <FormGroup>
                            <Label>Generate for Colour</Label>
                            <Select
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={getValues('color').find(c => c.id === aiColourId) || null}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                onChange={(e) => setAiColourId(e ? e.id : null)}
                                isClearable
                                placeholder="Select colour (optional — defaults to first)"
                                options={getValues('color') || []}
                            />
                        </FormGroup>
                    )}

                    {aiMode === "generate" && (
                        <FormGroup className="mt-3">
                            <Label>Shot Types</Label>
                            <Select
                                isMulti={true}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                value={aiShotTypes}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                onChange={(e) => {
                                    const selected = e || [];
                                    setAiShotTypes(selected);
                                    setAiNumImages(selected.length > 0 ? selected.length : null);
                                }}
                                placeholder="Select shot types..."
                                options={[
                                    { value: "fabric_roll", label: "Fabric Roll" },
                                    { value: "fabric_fold", label: "Fabric Fold" },
                                    { value: "fabric_drape", label: "Fabric Drape" },
                                    { value: "fabric_hanging", label: "Fabric Hanging" },
                                    { value: "still_life", label: "Still Life" },
                                    { value: "macro", label: "Macro Close-up" },
                                    { value: "model_wearing", label: "Model Wearing" },
                                ]}
                            />
                            {aiShotTypes.length === 0 && (
                                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                                    Using shot types from AI Settings.
                                </div>
                            )}
                        </FormGroup>
                    )}

                    {aiMode === "generate" && (
                        <FormGroup className="mt-3">
                            <Label>Number of Images</Label>
                            <Input
                            type="select"
                            value={aiNumImages || ""}
                            onChange={(e) => setAiNumImages(e.target.value ? parseInt(e.target.value, 10) : null)}
                            >
                            <option value="">Auto (1 per shot type)</option>
                            {Array.from({ length: 5 }, (_, i) => i + 1).map((n) => (
                                <option key={n} value={n}>
                                {n}
                                </option>
                            ))}
                            </Input>
                            <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                            Defaults to 1 per shot type. Images cycle through selected shot types.
                            </div>
                        </FormGroup>
                    )}

                    <FormGroup className="mt-3">
                    <Label>Additional Instructions</Label>
                    <Input
                        type="textarea"
                        rows={4}
                        placeholder="Any extra instructions specific to this product…"
                        value={aiPrompt}
                        onChange={(e) => setAiPrompt(e.target.value)}
                    />
                    <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                        The main prompt is configured globally in AI Settings. Use this field for any extra instructions specific to this product.
                    </div>
                    </FormGroup>

                    <FormGroup className="mt-3">
                    <Label>Aspect Ratio</Label>
                    <Input
                        type="select"
                        value={aiAspectRatio}
                        onChange={(e) => setAiAspectRatio(e.target.value)}
                    >
                        <option value="1:1">Square (1:1)</option>
                        <option value="3:4">Portrait (3:4)</option>
                        <option value="4:3">Landscape (4:3)</option>
                        <option value="9:16">Portrait (9:16)</option>
                        <option value="16:9">Landscape (16:9)</option>
                    </Input>
                    </FormGroup>
                </ModalBody>

                <ModalFooter>
                    <Button
                    type="button"
                    color="secondary"
                    onClick={() => setAiMode(null)}
                    disabled={aiSubmitting}
                    >
                    Cancel
                    </Button>

                    <Button
                    type="button"
                    color="primary"
                    onClick={async () => {
                        if (aiSubmittingRef.current) return; // guard against double/triple clicks
                        aiSubmittingRef.current = true;

                        // Mark the button busy immediately so it shows a spinner and disables
                        // during the readiness check too (that call can be slow on first run).
                        setAiSubmitting(true);

                        try {
                            const productId = getValues("id");

                            // For generation, run the readiness check BEFORE showing the processing
                            // overlay: hard-block when there is no reference image, and ask for
                            // confirmation when recommended details (composition/GSM) are missing.
                            if (aiMode === "generate") {
                                let readiness = null;
                                try {
                                    const {response} = await checkAiImageReadinessApi(productId, aiColourId);
                                    readiness = response;
                                } catch (e) {
                                    // Readiness check failed (network/permission) — fall through and let
                                    // the generate request surface the authoritative error.
                                }

                                if (readiness) {
                                    // Hard block — no reference image to anchor on.
                                    if (!readiness.can_generate) {
                                        toast.error(
                                            "Please add at least one real fabric image" +
                                            (aiColourId ? " for the selected colour" : "") +
                                            " before generating with AI.",
                                            {position: toast.POSITION.TOP_RIGHT}
                                        );
                                        return;
                                    }

                                    // Soft warning — recommended details missing. Confirm before spending the call.
                                    const missing = readiness.missing_recommended || [];
                                    if (missing.length > 0) {
                                        const labels = {composition: "Composition", gsm: "GSM"};
                                        const pretty = missing.map(m => labels[m] || m).join(", ");
                                        const confirm = await SweetAlert.fire({
                                            title: "Some product details are missing",
                                            html: `<b>${pretty}</b> ${missing.length > 1 ? "are" : "is"} not set for this product.<br/>` +
                                                "Missing details can reduce the quality of the AI-generated images.<br/><br/>" +
                                                "Do you still want to generate?",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonText: "Generate anyway",
                                            cancelButtonText: "Cancel",
                                            reverseButtons: true,
                                        });
                                        if (!confirm.value) {
                                            return; // user chose to add details first
                                        }
                                    }
                                }
                            }

                            setAiProcessing(true); // overlay only for the actual generation

                            const action =
                                aiMode === "generate"
                                    ? generateAiProductImages({
                                        productId,
                                        additional_instructions: aiPrompt || undefined,
                                        shot_types: aiShotTypes.length > 0 ? aiShotTypes.map(s => s.value) : undefined,
                                        aspect_ratio: aiAspectRatio,
                                        num_images: aiNumImages || undefined,
                                        colour_id: aiColourId || undefined,
                                    })
                                    : retouchAiProductImages({
                                        productId,
                                        prompt: aiPrompt,
                                        aspect_ratio: aiAspectRatio,
                                    });

                            const res = await dispatch(action);
                            if (!res.error) {
                                // generate returns { images, ... }; retouch returns the array directly
                                const newImages = res.payload?.images ?? res.payload;
                                setValue("images", newImages);
                                trigger("images");
                                setDragulaKey(dragulaKey + 1);

                                // reset UI
                                setAiPrompt("");
                                setAiAspectRatio("1:1");
                                setAiNumImages(null);
                                setAiShotTypes([]);
                                setAiColourId(null);
                                setAiMode(null);
                            }
                        } finally {
                            setAiProcessing(false);
                            setAiSubmitting(false);
                            aiSubmittingRef.current = false;
                        }
                    }}
                    disabled={aiSubmitting}
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                    >
                    {aiSubmitting ? <Spinner size="sm" /> : <MdAutoAwesome />}
                    Continue
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    )
};

export default ProductImage;

